'use client';

/**
 * Fires a formSubmit event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useFormSubmitEvent();
 * fireEvent({
 *    formName: 'search',
 *    formContent: searchValue,
 *    formContent2: displayName,
 * });
 * @param {Object} values - values to use for the event
 * @param {string} values.formContent - information about a form e.g. searched term, Product of interest, non PII field inputs
 * @param {string} values.formContent2 - information about a form e.g. searched term, Product of interest, non PII field inputs
 * @param {string} values.formFieldCausingError -  If the form submit was prevented by a field / fields that were not properly filled out, pass the names of those fields here. On successful form submits, pass empty string. e.g. email, phone number
 * @param {string} values.formLocation - Form location on the page (where on the page not which page, only in cases there are multiple instances of the form on a page). e.g. CATRetail_HPEspotTop
 * @param {string} values.formName - Name of the submitted form. e.g. Contact Us
 * @param {string} values.pagePath -  Page on which the formSubmit data layer push occurred. e.g. /en/search/search-results.html
 * @param {string} values.formStatus - Was the form submit a success or fail including details about the fail, if applicable. e.g. success, fail
 */

import { sendGTMEvent } from '@next/third-parties/google';
import {
  EVENT_FORM_SUBMITTED,
  STATUS_SUCCESS
} from 'constants/analyticsConstants';
import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

export const useFormSubmitEvent = () => {
  const pathname = usePathname();

  const buildEvent = useCallback(
    ({
      formContent = '',
      formContent2 = '',
      formFieldCausingError = '',
      formLocation = '',
      formName = '',
      pagePath = pathname,
      formStatus = STATUS_SUCCESS,
      formAdditionalContent = ''
    }) => ({
      event: EVENT_FORM_SUBMITTED,
      formFieldCausingError,
      formName,
      formContent,
      formContent2,
      formStatus,
      formLocation,
      pagePath,
      formAdditionalContent
    }),
    [pathname]
  );

  const fireEvent = useCallback(
    (values) => {
      const event = buildEvent(values);
      sendGTMEvent(event);
    },
    [buildEvent]
  );
  return { fireEvent };
};
